/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export * from './ApprovalsAppList.component';
export * from './ApprovalsAppListItem';
export { ApprovalsAppListContainer as ApprovalsAppList } from './ApprovalsAppList.container';
